// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vD3B9","content":"styles_content__Dl5QL","text":"styles_text__IAOdH","buttons":"styles_buttons__wHBjr"};